import React from "react";
import { CreatePasswordForm } from "../components";
import { useState } from "react";


function CreatePassword() {
  
  return (
    <div>
      <div className="bg-img-main">
        <div className="bg-img"></div>
      </div>

      {/* ========================Home-Banner===================  */}
      <section id="banner">
        <div className="custom-container">
          <div className="sec-padding">
            <div className="row">
              <div className="col-lg-12">
                <div className="main">
                  <CreatePasswordForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CreatePassword;
